<template>
  <nav
    :class="componentClass"
    :style="componentStyle"
  >
    <h2
      v-if="!hasNoTitle"
      :class="titleClass"
      style="letter-spacing: var(--letter-spacing-xl); font-weight: var(--font-weight-bold)"
    >
      {{ title }}
    </h2>
    <slot />
  </nav>
</template>

<script>
  export default {
    name: 'JumpToNav',

    props: {
      breakWords: {
        type: Boolean,
        default: true
      },
      hasNoTitle: {
        type: Boolean,
        default: false
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        default: 'Jump to'
      },
      titleClass: {
        type: String,
        default: 'h5 text-uppercase size-md'
      }
    },

    computed: {
      componentClass() {
        return ['nav nav-jump-to tablet:size-sm']
      },
      componentStyle() {
        let style = {}

        if (this.breakWords) {
          style['word-break'] = 'break-word'
        }

        return {
          ...style,
          ...{
            'color': 'var(--fa-md-gravy)',
            '--link-color': 'var(--fa-md-gravy)',
            '--link-decoration-line': 'none'
          },
          ...this.customStyle
        }
      }
    }
  }
</script>
